@if (form) {
  <div class="box-signle mt-3">
    <div class="row">
      <div class="col-12">
        <p><span [innerHTML]="form.question_name"></span> @if (form.question_required) {
          <span class="required">*</span>
        }</p>
        <div class="box-date">
          <p-datepicker [disabled]="form.view" styleClass="w-100" [(ngModel)]="date" [timeOnly]="true"
          [showIcon]="true" (onSelect)="updateValue()"></p-datepicker>
        </div>
        <!-- <app-validate-items [action]="form.question_required" [valid]="date" (validUpdate)="updateValiDate($event)">
        <div class="box-date">
          <p-datepicker [disabled]="form.view" styleClass="w-100" [(ngModel)]="date" [timeOnly]="true"
          [showIcon]="true" (onSelect)="updateValue()"></p-datepicker>
        </div>
      </app-validate-items> -->
    </div>
  </div>
</div>
}